import { getAccessToken } from './tokenStore';

export const CHAT_WS_AUTH_CODES = new Set([4401, 4403]);

// K4 Aşama 3 (owner, 2026-10-13): the access token is kept in memory
// (utils/tokenStore.js), no longer in localStorage.
export const chatAccessToken = () => getAccessToken() || '';

export const isChatWsAuthClose = (code) => CHAT_WS_AUTH_CODES.has(Number(code));

export const isChatHttpAuthError = (err) => {
  const status = err?.response?.status;
  return status === 401 || status === 403;
};

export const chatWsBackoffMs = (attempt) => Math.min(1000 * (2 ** attempt), 30000);

export const chatWsBusy = (socket) => {
  if (!socket) return false;
  return socket.readyState === WebSocket.CONNECTING || socket.readyState === WebSocket.OPEN;
};
